import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../../../firebase-config';
import { isLikelyPhotoFilename } from './evidenceFileClassify';

/**
 * Append-only staff access log when opening evidence (especially photos).
 * Failures must never block opening the file.
 */
export async function logEvidenceFileAccess({
  schoolId,
  fileName,
  fileUrl,
  actor,
  surface = 'unknown',
}) {
  try {
    const name = String(fileName || '');
    const isPhoto = isLikelyPhotoFilename(name);
    await addDoc(collection(db, 'evidenceAccessLogs'), {
      schoolId: String(schoolId || ''),
      fileName: name,
      fileUrl: fileUrl || null,
      isPhoto,
      surface,
      actorUid: actor?.uid || null,
      actorEmail: actor?.email || null,
      actorName: actor?.displayName || null,
      accessedAt: serverTimestamp(),
    });
  } catch (err) {
    console.error('logEvidenceFileAccess failed', err);
  }
}

export async function openEvidenceFileWithAccessLog({
  schoolId,
  file,
  actor,
  surface,
}) {
  await logEvidenceFileAccess({
    schoolId,
    fileName: file?.name,
    fileUrl: file?.url,
    actor,
    surface,
  });
  if (file?.url) {
    window.open(file.url, '_blank', 'noopener,noreferrer');
  }
}